import React from 'react';

import PageHeader from '@shared/PageHeader';
import useOperatorProductLabelTemplateService from '@hooks/operator/product_label_templates/useOperatorProductLabelTemplateService';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';
import ProductLabelTemplatesEdit from '@shared/product_label_templates/ProductLabelTemplatesEdit';

const ProductLabelTemplatesEditPage: React.FC = () => {
  // id 由 shared ProductLabelTemplatesEdit 自己從 useParams 讀，這裡不需要再拿一次。
  // useOperatorProductLabelTemplateService 是 .js 且 JSDoc 標 `@returns {Object}`，
  // TS 看不到方法欄位，cast 為 any 保留 runtime 行為。
  const {
    getById,
    create,
    update,
    getDefaultTemplate,
  } = useOperatorProductLabelTemplateService() as any;
  const productService = useOperatorProductService();
  const { handleRecordLoaded, recordMerchantId, merchantDataLoading } = useRecordMerchantSync();

  // 編輯模式：wrapper 由 onTemplateLoaded 拿到 record's merchant_id 後同步 context，
  // 整個過程 merchantDataLoading 為 true 擋住 form 渲染，避免閃錯的下拉。
  // ProductSelect 等 merchant-scoped 元件直接吃 record's merchant_id（record-first），
  // 不再依賴 currentMerchant，避免多商家 operator 切換 header 後寫壞跨 merchant 資料。
  return (
    <div>
      <PageHeader items={['products', 'products.label_templates', 'products.label_templates.edit']} />
      <ProductLabelTemplatesEdit
        role="operator"
        getById={getById}
        create={create}
        update={update}
        getDefaultTemplate={getDefaultTemplate}
        productService={productService}
        merchantIdForFilters={recordMerchantId}
        onTemplateLoaded={handleRecordLoaded}
        merchantDataLoading={merchantDataLoading}
      />
    </div>
  );
};

export default ProductLabelTemplatesEditPage;
